import { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CMM } from '../../Lib/Cmm.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Header from "components/Headers/Header.js";
import { NavLink as NavLinkRRD, Link, useLocation, useNavigate } from "react-router-dom";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import { fetchAxios, postAxios, postNoauth } from 'Lib/GetAxios';
import { etcStore } from 'store/etcStore';
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Container,
  Row,
  Col,
  Input,
} from "reactstrap";

let maxPageNo;

const Notification = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [detail, setDetail] = useState([]);

  const [viewNo, setViewNo] = useState(3);
  const [selectNo, setSelectNo] = useState(1);

  //데이터 가져오기
  useEffect(() => {

    lodeData();
    getUser();

  }, []);

  useEffect(() => {
    lodeData();
  }, [selectNo]);


  //
  const getUser = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/get_user_idx`,
      {})
      .then((res) => {
        if (res != 'ERROR') {

          etcStore.updMainData({ ...etcStore.mainData, notification_userIdx: res[0].user_idx });

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, []);

  //데이터 받아오기
  const lodeData = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/noti_list`,
      {
        pageno: selectNo,
      })
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);

          setData(res[0]);

          var roomCnt = res[1][0].count;
          maxPageNo = Math.ceil(roomCnt / 10);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [selectNo, data]);

  //상세 데이터 가져오기
  const getDetail = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/noti_detail`,
      {
        idx: etcStore.mainData.notification_uuid,
      })
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);

          setDetail(res);
        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [etcStore.mainData.notification_uuid]);


  const toastMessage = () => {
    //토스트 메시지
    toast.success('성공적으로 변경되었습니다.', {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  //페이지 이동 버튼
  const PageNoBtn = ({ maxPage }) => {


    const getPageNumbers = () => {
      const numbers = [];
      const start = Math.max(1, Math.min(viewNo - 2, maxPage - 4)); // 시작 페이지
      const end = Math.min(start + 4, maxPage); // 끝 페이지

      for (let i = start; i <= end; i++) {
        numbers.push(i);
      }

      return numbers;
    };

    return (
      <Row className="justify-content-center">
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo >= 3) {
              setViewNo(3);

            }
          }}><AiOutlineDoubleLeft /></Button>
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo >= 3) {
              setViewNo(viewNo - 5);
            }
          }}><GoChevronLeft /> </Button>
        {getPageNumbers().map((index) => (
          <Button
            key={index}
            className={`btn btn-sm text-break ml-3 mr-3 shadow-none border-0 `}
            style={selectNo == index ? { backgroundColor: '#3094FF', color: '#fff', alignItems: 'center' } : { backgroundColor: '#FFF', alignItems: 'center' }}
            onClick={(e) => {
              setSelectNo(index);
            }
            }
          >
            {index}
          </Button>
        ))
        }
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo <= maxPageNo - 4) {
              setViewNo(viewNo + 5);
            }
          }}><GoChevronRight /></Button>
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo <= maxPageNo - 4) {
              setViewNo(maxPageNo - 2);
              console.log(viewNo);
            }
          }}>< AiOutlineDoubleRight /></Button>
      </Row >
    );
  }

  return (
    <>
      <Header />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
      <Container className="mt--7 position-absolute start-0" fluid style={{ maxWidth: '1300px', }}>

        <Card>
          <CardHeader className="bg-white">
            <div className="font-weight-bold d-none d-sm-block"
              style={{ lineHeight: 1.2 }}>
              <h1 className="d-inline-block"
                style={{ color: 'black' }}>
                공지 사항</h1>
              {(etcStore.mainData.notification_userIdx == '100000') &&
                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style={{ cursor: 'pointer', outline: 'none', width: '20px' }}
                  className="ml-2 mb-2"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/admin/noti_edit');
                    etcStore.updMainData({ ...etcStore.mainData, notificationEdit_uuid: '' });
                  }}>
                  <path d="M0 57.01V72.01H15L59.24 27.77L44.24 12.77L0 57.01Z" fill="#434343" />
                  <path d="M70.84 10.53L61.48 1.17C59.92 -0.39 57.4 -0.39 55.84 1.17L48.52 8.49L63.52 23.49L70.84 16.17C72.4 14.61 72.4 12.09 70.84 10.53Z" fill="#434343" />
                </svg>}
            </div>
            <div className="font-weight-bold d-sm-none "
              style={{ lineHeight: 1.2 }}>
              <h2 className="d-inline-block"
                style={{ color: 'black' }}>
                공지 사항</h2>
            </div>
          </CardHeader>
          {!(detail && detail.length > 0) &&
            <>
              <CardBody className=" p-0 d-none d-sm-block" style={{ minHeight: '700px' }}>
                <Col className="mb-xl-0 p-0">
                  {data.map((item, index) => (
                    <Card key={index} className="shadow"
                      onClick={(e) => {
                        etcStore.updMainData({ ...etcStore.mainData, notification_uuid: item.noti_idx });
                        getDetail();
                      }}>
                      <CardHeader className="bg-transparent">
                        <Row className="ml-1">
                          <h3 className="mb-0">{item.title}</h3>
                        </Row>
                      </CardHeader>

                    </Card>
                  ))}
                </Col>
              </CardBody>
              <CardBody className=" p-0  d-sm-none" style={{ minHeight: '400px' }}>
                <Col className="mb-xl-0 p-0">
                  {data.map((item, index) => (
                    <Card key={index} className="shadow"
                      onClick={(e) => {
                        etcStore.updMainData({ ...etcStore.mainData, notification_uuid: item.noti_idx });
                        getDetail();
                      }}>
                      <CardHeader className="bg-transparent">
                        <Row className="ml-1">
                          <h3 className="mb-0">{item.title}</h3>
                        </Row>
                      </CardHeader>

                    </Card>
                  ))}
                </Col>
              </CardBody>

            </>

          }
          {(detail && detail.length > 0) &&
            <CardBody className=" p-0 ">
              <div>
                <div
                  className="text-break  shadow-none border-0 px-1 bg-white"
                  style={{ cursor: 'pointer', outline: 'none' }}
                  onClick={(e) => {
                    e.preventDefault();
                    setDetail([]);
                  }}><GoChevronLeft className="" style={{ height: '22px', width: '22px' }} /> </div>
              </div>
              <div className="mx-4 mb-4 mt-2">
                <div className=" flex-lg-row justify-content-between">
                  <div className="text-lg font-weight-bold d-inline-block" style={{ color: '#4A4A4A' }}>{detail[0].title}</div>
                  {(etcStore.mainData.notification_userIdx == '100000') &&
                    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg"
                      style={{ cursor: 'pointer', outline: 'none', width: '20px' }}
                      className="ml-2 mb-2 d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/admin/noti_edit`);
                        etcStore.updMainData({ ...etcStore.mainData, notificationEdit_uuid: etcStore.mainData.notification_uuid });
                      }}>
                      <path d="M0 57.01V72.01H15L59.24 27.77L44.24 12.77L0 57.01Z" fill="#434343" />
                      <path d="M70.84 10.53L61.48 1.17C59.92 -0.39 57.4 -0.39 55.84 1.17L48.52 8.49L63.52 23.49L70.84 16.17C72.4 14.61 72.4 12.09 70.84 10.53Z" fill="#434343" />
                    </svg>}
                </div>
                <div className="mx-2  " style={{ whiteSpace: 'pre-line', color: '#333333' }}>
                  {/* {detail[0].note} */}
                  <div className="mx-10 text-[#555555]">
                    <p class='ql-editor w-100' dangerouslySetInnerHTML={{ __html: detail[0].note }}></p>
                  </div>
                </div>
              </div>
            </CardBody>
          }
          {!(detail && detail.length > 0) &&
            <div className="p-2 bg-white " style={{ height: '70px' }} >
              <PageNoBtn maxPage={maxPageNo} />
            </div>
          }
        </Card>
      </Container >
    </>
  );
};

export default Notification;
